// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1C1Xd","resendInfoText":"OnGoingPaymentBox_resendInfoText__3yi-V"};